<script>
import { defraFactors as _API_ } from "./api-calls";
import { locationHelper as _LOCATION_API_ } from "./api-calls";
import { defraCategories as _CATEGORIES_API_ } from "./api-calls";
import { defraActivities as _ACTIVITIES_API_ } from "./api-calls";
import { defraTypes as _TYPES_API_ } from "./api-calls";
import { defraFuels as _FUELS_API_ } from "./api-calls";
import { defraUnits as _UNITS_API_ } from "./api-calls";

export default {
    data() {
        return {
            loading: true,
            data: [],
            newlyAddedData: [],

            datasets: {
                countries: {},
                categories: {},
                activities: {},
                types: {},
                fuels: {},
                units: {},
                rf_methods: {
                    'no_rf': {
                        value: null,
                        text: this.$t('carbon-admin.headers.no_rf')
                    },
                    'without_rf': {
                        value: 'Without RF',
                        text: this.$t('carbon-admin.headers.without_rf')
                    },
                    'with_rf': {
                        value: 'With RF',
                        text: this.$t('carbon-admin.headers.with_rf')
                    },
                },
            },

            selectedLanguage: 'en',
            languages: [
                { value: 'en', text: 'EN' },
                { value: 'tr', text: 'TR' },
            ],

            headers: [
                {
                    key: '#',
                    in: 'index',
                    type: null,
                    style: {
                        'flex': .5,
                        'text-align': 'center'
                    },
                    interactOptions: undefined
                },
                {
                    key: 'category',
                    in: 'category',
                    type: 'sub',
                    style: {
                        'flex': 1,
                        'text-align': 'center'
                    },
                    interactOptions: {
                        type: 'select',
                        datasetKey: 'categories',
                        referencedKey: 'category_id',
                        boundModel: 'id'
                    }
                },
                {
                    key: 'activity',
                    in: 'activity',
                    type: 'sub',
                    style: {
                        'flex': 2,
                        'text-align': 'center'
                    },
                    interactOptions: {
                        type: 'select',
                        datasetKey: 'activities',
                        referencedKey: 'activity_id',
                        boundModel: 'id'
                    }
                },
                {
                    key: 'type',
                    in: 'type',
                    type: 'sub',
                    style: {
                        'flex': 2,
                        'text-align': 'center'
                    },
                    interactOptions: {
                        type: 'select',
                        datasetKey: 'types',
                        referencedKey: 'type_id',
                        boundModel: 'id'
                    }
                },
                {
                    key: 'fuel',
                    in: 'fuel',
                    type: 'sub',
                    style: {
                        'flex': 2,
                        'text-align': 'center'
                    },
                    interactOptions: {
                        type: 'select',
                        datasetKey: 'fuels',
                        referencedKey: 'fuel_id',
                        boundModel: 'id'
                    }
                },
                {
                    key: 'country',
                    in: 'country',
                    type: 'location',
                    style: {
                        'flex': 1,
                        'text-align': 'center'
                    },
                    interactOptions: {
                        type: 'select',
                        datasetKey: null,
                        referencedKey: 'country_id',
                        boundModel: 'country_id'
                    }
                },
                {
                    key: 'state',
                    in: 'state',
                    type: 'location',
                    style: {
                        'flex': 1,
                        'text-align': 'center'
                    },
                    interactOptions: {
                        type: 'select',
                        datasetKey: null,
                        referencedKey: 'country_id',
                        boundModel: 'state_id'
                    }
                },
                {
                    key: 'rf_method',
                    in: 'main',
                    type: 'default',
                    style: {
                        'flex': 1,
                        'text-align': 'center'
                    },
                    interactOptions: {
                        type: 'select',
                        datasetKey: 'rf_methods',
                        referencedKey: 'rf_method',
                        boundModel: 'rf_method'
                    }
                },
                {
                    key: 'kgco2e',
                    in: 'main',
                    type: 'default',
                    style: {
                        'flex': 1,
                        'text-align': 'center'
                    },
                    interactOptions: {
                        type: 'number',
                        datasetKey: null,
                        referencedKey: null,
                        boundModel: 'kgco2e'
                    }
                },
                {
                    key: 'kgco2e_co2',
                    in: 'main',
                    type: 'default',
                    style: {
                        'flex': 1,
                        'text-align': 'center'
                    },
                    interactOptions: {
                        type: 'number',
                        datasetKey: null,
                        referencedKey: 'kgco2e_co2',
                        boundModel: 'kgco2e_co2'
                    }
                },
                {
                    key: 'kgco2e_ch4',
                    in: 'main',
                    type: 'default',
                    style: {
                        'flex': 1,
                        'text-align': 'center'
                    },
                    interactOptions: {
                        type: 'number',
                        datasetKey: null,
                        referencedKey: 'kgco2e_ch4',
                        boundModel: 'kgco2e_ch4'
                    }
                },
                {
                    key: 'kgco2e_n2o',
                    in: 'main',
                    type: 'default',
                    style: {
                        'flex': 1,
                        'text-align': 'center'
                    },
                    interactOptions: {
                        type: 'number',
                        datasetKey: null,
                        referencedKey: 'kgco2e_n2o',
                        boundModel: 'kgco2e_n2o'
                    }
                },
                {
                    key: 'kgco2e_non_kyoto',
                    in: 'main',
                    type: 'default',
                    style: {
                        'flex': 1,
                        'text-align': 'center'
                    },
                    interactOptions: {
                        type: 'number',
                        datasetKey: null,
                        referencedKey: 'kgco2e_non_kyoto',
                        boundModel: 'kgco2e_non_kyoto'
                    }
                },
                {
                    key: 'kgco2e_kyoto',
                    in: 'main',
                    type: 'default',
                    style: {
                        'flex': 1,
                        'text-align': 'center'
                    },
                    interactOptions: {
                        type: 'number',
                        datasetKey: null,
                        referencedKey: 'kgco2e_kyoto',
                        boundModel: 'kgco2e_kyoto'
                    }
                },
                {
                    key: 'kwh',
                    in: 'main',
                    type: 'default',
                    style: {
                        'flex': 1,
                        'text-align': 'center'
                    },
                    interactOptions: {
                        type: 'number',
                        datasetKey: null,
                        referencedKey: 'kwh',
                        boundModel: 'kwh'
                    }
                },
            ],

            createData: undefined,
            editData: undefined,
        }
    },

    computed: {
        interactiveHeaders() {
            return this.headers.filter(x => x.interactOptions != undefined);
        }
    },

    async mounted() {
        await this.fetchCountry();
        await this.fetchCategoriesRequest();
        await this.fetchActivitiesRequest();
        await this.fetchTypesRequest();
        await this.fetchFuelsRequest();
        await this.fetchUnitsRequest();
        await this.fetchRequest();
    },

    methods: {
        async fetchCountry() {
            await _LOCATION_API_.fetch()
                .then(res => {
                    for (let i = 0; i < res.data.length; i++) {
                        const country = res.data[i];
                        this.datasets['countries'][`id_${country.add_country_id}`] = {
                            country_id: country.add_country_id,
                            country_name: country.add_country_name,
                            has_state: country.has_state,
                            states: {},
                        };

                        if (country.has_state === true) {
                            for (let j = 0; j < country.states.length; j++) {
                                const state = country.states[j];
                                this.datasets['countries'][`id_${country.add_country_id}`]['states'][`id_${state.add_state_id}`] = {
                                    state_id: state.add_state_id,
                                    state_name: state.add_state_name,
                                }
                            }
                        }
                    }
                })
        },

        async fetchCategoriesRequest() {
            await _CATEGORIES_API_.fetch()
                .then(async (res) => {
                    this.mapObject('categories', res.data);
                })
        },
        
        async fetchActivitiesRequest() {
            await _ACTIVITIES_API_.fetch()
                .then(async (res) => {
                    this.mapObject('activities', res.data);
                })
        },
        
        async fetchTypesRequest() {
            await _TYPES_API_.fetch()
                .then(async (res) => {
                    this.mapObject('types', res.data);
                })
        },
        
        async fetchFuelsRequest() {
            await _FUELS_API_.fetch()
                .then(async (res) => {
                    this.mapObject('fuels', res.data);
                })
        },
        
        async fetchUnitsRequest() {
            await _UNITS_API_.fetch()
                .then(async (res) => {
                    this.mapObject('units', res.data);
                })
        },
        
        async fetchRequest() {
            await this.setLoading(true);
            await _API_.fetch()
                .then(res => {
                    this.data = res.data;
                })
                .finally(async () => {
                    await this.setLoading(false);
                })
        },

        async mapObject(datasetKey, items) {
            for (let i = 0; i < items.length; i++) {
                const item = items[i];
                this.datasets[datasetKey][`id_${item.main_data.id}`] = {
                    id: item.main_data.id,
                    identifier: item.main_data.identifier,
                    en: item.text_data.en.name,
                    tr: item.text_data.tr.name,
                };
            }
        },
        
        async createRequest() {
            const params = {
                id: undefined,
                body: this.createData
            };

            await _API_.create(params)
                .then(res => {
                    this.createData.id = res.data.value;
                    this.newlyAddedData.unshift(this.createData);
                    this.$notify('success', res.data.messageName);
                })
                .catch(({ response }) => {
                    this.$notify('error', response.data.messageName);
                })
        },
        
        async updateRequest() {
            const params = {
                id: this.editData.id,
                body: this.editData
            };
            await _API_.update(params)
                .then(res => {
                    this.editData.updated_by = this.$user.user_id,
                    this.editData.updated_on = new Date(),
                    this.$notify('success', res.data.messageName);
                })
                .catch(({ response }) => {
                    this.$notify('error', response.data.messageName);
                })
        },
        
        async deleteRequest() {
            const params = {
                id: this.editData.id,
                body: undefined
            };
            await _API_.delete(params.id)
                .then(res => {
                    this.editData.is_deleted = true;
                    this.$notify('success', res.data.messageName);
                })
                .catch(({ response }) => {
                    this.$notify('error', response.data.messageName);
                })
                .finally(() => {
                    this.$refs.editPopup.startHideProcess();
                })
        },

        async handleClickCreate() {
            await this.setupCreateData();
            this.$refs.createPopup.openPopup();
        },

        async setupCreateData() {
            this.createData = {
                id: null,
                kgco2e: null,
                kgco2e_co2: null,
                kgco2e_ch4: null,
                kgco2e_n2o: null,
                kgco2e_non_kyoto: null,
                kgco2e_kyoto: null,
                kwh: null,
                rf_method: null,
                category_id: null,
                activity_id: null,
                type_id: null,
                fuel_id: null,
                unit_id: null,
                country_id: null,
                state_id: null,
                is_deleted: false
            }
        },

        resetCreateData() {
            Object.keys(this.createData).forEach(k => this.createData[k] = null);
        },

        async handleClickEdit(item) {
            await this.setupEditData(item);
            this.$refs.editPopup.openPopup();
        },

        async setupEditData(item) {
            this.editData = item;
        },

        async setLoading(bool) {
            this.loading = bool;
        }
    }
}
</script>

<template>
    <div class="flex-all-centered-col main-frame">
        <tab-selector 
            :options="languages" 
            :selectedTab="selectedLanguage" 
            @select-tab="($event) => selectedLanguage = $event.value"
        />

        <div v-if="!loading" 
            class="flex-all-centered-row" 
            style="justify-content: flex-end;"
        >
            <button class="sust-btn sust-btn-green"
                @click="handleClickCreate()"
            >
                {{ $t('misc.create-new') }}
            </button>
        </div>

        <div v-if="!loading" 
            class="table small-box-shadow"
        >
            <div class="table-row headers">
                <div v-for="h in headers" :key="h.key"
                    :style="h.style"
                >
                    {{ $t(`carbon-admin.headers.${h.key}`) }}
                </div>
            </div>
    
            <div class="values-wrapper">
                <div v-for="(item, idx) in newlyAddedData" :key="idx"
                    v-show="!item.is_deleted"
                    class="table-row values"
                    @click="handleClickEdit(item)"
                >
                    <div v-for="h in headers" :key="h.key"
                        :style="h.style"
                    >
                        <span v-if="h.in === 'index'">
                            {{ idx+1 }}
                        </span>
                        <span v-else-if="h.type === 'sub'">
                            {{ 
                                datasets[h.interactOptions.datasetKey][`id_${item[h.interactOptions.referencedKey]}`] ? 
                                    datasets[h.interactOptions.datasetKey][`id_${item[h.interactOptions.referencedKey]}`][selectedLanguage] : 
                                    '-'
                            }}
                        </span>
                        <span v-else-if="h.type === 'location' && h.key === 'country' && item.country_id">
                            {{ datasets.countries[`id_${item.country_id}`].country_name }}
                        </span>
                        <span v-else-if="h.type === 'location' && h.key === 'state' && item.state_id && datasets.countries[`id_${item.country_id}`].has_state">
                            {{ datasets.countries[`id_${item.country_id}`].states[`id_${item.state_id}`].state_name }}
                        </span>
                        <span v-else-if="h.type === 'default'">
                            <span v-if="h.key === 'rf_method'">
                                {{ item[h.key] ? $t(`carbon-admin.headers.${item[h.key]}`) : ' - ' }}
                            </span>
                            <span v-else>
                                {{ item[h.key] }}
                            </span>
                        </span>
                    </div>
                </div>
                <div v-for="(item, idx) in data" :key="idx"
                    v-show="!item.is_deleted"
                    class="table-row values"
                    @click="handleClickEdit(item)"
                >
                    <div v-for="h in headers" :key="h.key"
                        :style="h.style"
                    >
                        <span v-if="h.in === 'index'">
                            {{ idx+newlyAddedData.length+1 }}
                        </span>
                        <span v-else-if="h.type === 'sub'">
                            {{ 
                                datasets[h.interactOptions.datasetKey][`id_${item[h.interactOptions.referencedKey]}`] ? 
                                    datasets[h.interactOptions.datasetKey][`id_${item[h.interactOptions.referencedKey]}`][selectedLanguage] : 
                                    '-'
                            }}
                        </span>
                        <span v-else-if="h.type === 'location' && h.key === 'country' && item.country_id">
                            {{ datasets.countries[`id_${item.country_id}`].country_name }}
                        </span>
                        <span v-else-if="h.type === 'location' && h.key === 'state' && item.state_id && datasets.countries[`id_${item.country_id}`].has_state">
                            {{ datasets.countries[`id_${item.country_id}`].states[`id_${item.state_id}`].state_name }}
                        </span>
                        <span v-else-if="h.type === 'default'">
                            <span v-if="h.key === 'rf_method'">
                                {{ item[h.key] ? $t(`carbon-admin.headers.${item[h.key]}`) : ' - ' }}
                            </span>
                            <span v-else>
                                {{ item[h.key] }}
                            </span>
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <loading-spinner v-else :fontSize="'2em'" />

        <sust-popup ref="createPopup"
            size="md"
            :header="false"
            @ok="createRequest()"
        >
            <div v-if="createData" 
                class="flex-all-centered-row"
                style="
                    flex-wrap: wrap;
                    align-content: center;
                    align-items: stretch;
                    gap: 1em;
                "
            >
                <div v-for="header in interactiveHeaders" 
                    :key="header.key"
                    class="flex-all-centered-col"
                    style="margin: .35em 0; max-width: 40%;"
                >
                    <div style="font-weight: bold;">
                        {{ $t(`carbon-admin.headers.${header.key}`) }}
                    </div>
                    <select v-if="header.key === 'rf_method'"
                        v-model="createData.rf_method"
                        class="sust-input-field"
                        style="width: 100%; text-align: center;"
                    >
                        <option v-for="(value, key) in datasets.rf_methods"
                            :key="key"
                            :value="value.value"
                        >
                            {{ value.text }}
                        </option>
                    </select>
                    <select v-else-if="header.type === 'sub'"
                        v-model="createData[`${header.key}_id`]"
                        class="sust-input-field"
                        style="width: 100%; text-align: center;"
                    >
                        <option v-for="(value, key) in datasets[`${header.interactOptions.datasetKey}`]"
                            :key="key"
                            :value="value.id"
                        >
                            {{ value[selectedLanguage] ? value[selectedLanguage] : value.identifier }}
                        </option>
                    </select>
                    <select v-else-if="header.type === 'location' && header.key === 'country'"
                        v-model="createData.country_id"
                        class="sust-input-field"
                        style="width: 100%; text-align: center;"
                    >
                        <option v-for="(value, key) in datasets.countries"
                            :key="key"
                            :value="value.country_id"
                        >
                            {{ value.country_name }}
                        </option>
                    </select>
                    <select v-else-if="header.type === 'location' && header.key === 'state'"
                        :disabled="createData.country_id === null || datasets.countries[`id_${createData.country_id}`].has_state === false"
                        v-model="createData.state_id"
                        class="sust-input-field specially-disabled"
                        style="width: 100%; text-align: center;"
                    >
                        <option v-for="(value, key) in createData.country_id ? datasets.countries[`id_${createData.country_id}`].states : {}"
                            :key="key"
                            :value="value.state_id"
                        >
                            {{ value.state_name }}
                        </option>
                    </select>
                    <input v-else-if="header.interactOptions.type === 'number'"
                        v-model="createData[header.interactOptions.boundModel]"
                        type="number"
                        class="sust-input-field"
                        style="width: 100%; text-align: center;"
                        min="0"
                    >
                </div>
            </div>
        </sust-popup>
        
        <sust-popup ref="editPopup"
            size="md"
            :header="false"
            @ok="updateRequest()"
            @onHide="() => editData = undefined"
        >
            <div v-if="editData" 
                class="flex-all-centered-row"
                style="
                    flex-wrap: wrap;
                    align-content: center;
                    align-items: stretch;
                    gap: 1em;
                "
            >
                <div v-for="header in interactiveHeaders" 
                    :key="header.key"
                    class="flex-all-centered-col"
                    style="margin: .35em 0; max-width: 40%;"
                >
                    <div style="font-weight: bold;">
                        {{ $t(`carbon-admin.headers.${header.key}`) }}
                    </div>
                    <select v-if="header.key === 'rf_method'"
                        v-model="editData.rf_method"
                        class="sust-input-field"
                        style="width: 100%; text-align: center;"
                    >
                        <option v-for="(value, key) in datasets.rf_methods"
                            :key="key"
                            :value="value.value"
                        >
                            {{ value.text }}
                        </option>
                    </select>
                    <select v-else-if="header.type === 'sub'"
                        v-model="editData[`${header.key}_id`]"
                        class="sust-input-field"
                        style="width: 100%; text-align: center;"
                    >
                        <option v-for="(value, key) in datasets[`${header.interactOptions.datasetKey}`]"
                            :key="key"
                            :value="value.id"
                        >
                            {{ value[selectedLanguage] ? value[selectedLanguage] : value.identifier }}
                        </option>
                    </select>
                    <select v-else-if="header.type === 'location' && header.key === 'country'"
                        v-model="editData.country_id"
                        class="sust-input-field"
                        style="width: 100%; text-align: center;"
                    >
                        <option v-for="(value, key) in datasets.countries"
                            :key="key"
                            :value="value.country_id"
                        >
                            {{ value.country_name }}
                        </option>
                    </select>
                    <select v-else-if="header.type === 'location' && header.key === 'state'"
                        :disabled="editData.country_id === null || datasets.countries[`id_${editData.country_id}`].has_state === false"
                        v-model="editData.state_id"
                        class="sust-input-field specially-disabled"
                        style="width: 100%; text-align: center;"
                    >
                        <option v-for="(value, key) in editData.country_id ? datasets.countries[`id_${editData.country_id}`].states : {}"
                            :key="key"
                            :value="value.state_id"
                        >
                            {{ value.state_name }}
                        </option>
                    </select>
                    <input v-else-if="header.interactOptions.type === 'number'"
                        v-model="editData[header.interactOptions.boundModel]"
                        type="number"
                        class="sust-input-field"
                        style="width: 100%; text-align: center;"
                        min="0"
                    >
                </div>
            </div>

            <template #footer="{ hide }">
                <div class="flex-all-centered-row"
                    style="justify-content: space-between; padding: .5em;"
                >
                    <button class="sust-btn sust-btn-red"
                        @click="() => {
                            $refs.deletePopup.openPopup()
                        }"
                    >
                        {{ $t('misc.delete') }}
                    </button>

                    <div class="flex-all-centered-row"
                        style="justify-content: flex-end;"
                    >
                        <button class="sust-btn sust-btn-red"
                            @click="hide()"
                        >
                            {{ $t('misc.cancel') }}
                        </button>
                        <button class="sust-btn sust-btn-green"
                            style="margin-left: 1em;"
                            @click="() => {
                                updateRequest(); 
                                hide();
                            }"
                        >
                            {{ $t('misc.save') }}
                        </button>
                    </div>
                </div>
            </template>
        </sust-popup>

        <sust-popup ref="deletePopup"
            size="sm"
            :title="$t('carbon-admin.titles.delete')"
            @ok="deleteRequest()"
        >
            {{ $t('carbon-admin.warnings.delete') }}
        </sust-popup>
    </div>
</template>

<style lang='scss' scoped>
@import "../../../assets/css/carbon-admin-page.scss";

.values {
    padding: 0 !important;
    > div {
        padding: .35em 0;
        border-right: thin solid rgba(211, 211, 211, 0.25);
        &:last-of-type {
            border-right: 0 !important;
        }
    }
}
</style>